export const CategoryExperiencesActionTypes = {
  API_RESPONSE_SUCCESS: '@@category-experiences/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@category-experiences/API_RESPONSE_ERROR',

  GET_CATEGORY_EXPERIENCE: '@@category-experiences/GET_CATEGORY_EXPERIENCE',
  LIST_CATEGORIES_EXPERIENCE: '@@category-experiences/LIST_CATEGORIES_EXPERIENCE',
  ADD_CATEGORY_EXPERIENCE: '@@category-experiences/ADD_CATEGORY_EXPERIENCE',
  UPDATE_CATEGORY_EXPERIENCE: '@@category-experiences/UPDATE_CATEGORY_EXPERIENCE',
  DELETE_CATEGORY_EXPERIENCE: '@@category-experiences/DELETE_CATEGORY_EXPERIENCE',

  RESET: '@@category-experiences/RESET'
}
